type SignUpCopy = {
  headline: string;
  body: string;
  cta: string;
};

export function getSignUpCopy(isYearsAhead: boolean, companyName = ''): SignUpCopy {
  if (isYearsAhead) {
    return {
      headline: 'Find Senior Care with Years Ahead',
      body: 'Use the needs assessment and gain access to the resource library and dynamic search tools to get the right care for your family',
      cta: 'Continue',
    };
  }

  const trimmedName = (companyName ?? '').trim();
  return {
    headline: trimmedName ? `Your Sittercity benefit from ${trimmedName}` : 'Your Sittercity benefit',
    body: 'Activate your free Sittercity membership ($180/year\xa0value) to find local caregivers, review profiles, and connect with sitters who fit your needs.',
    cta: 'Sign up for free',
  };
}
